import { render, staticRenderFns } from "./headNav.vue?vue&type=template&id=c508e39e&"
import script from "./headNav.vue?vue&type=script&lang=js&"
export * from "./headNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports